"use client"

import React from "react";
import { useSession } from "next-auth/react";
import { useTranslations } from "next-intl";
import cn from "classnames";
import {
    Col,
    Flex,
    Rate,
    Row,
    Space,
    Spin,
    Typography
} from "antd";
import style from './roles.module.scss'
import {
    Card,
    AddButton,
    OptionsButton,
    Button
} from "@/theme/ui";
import { useApi } from "@/lib/hook";
import {
    CharacterIcon,
    EditIcon,
} from "@/theme/assets/icons";
import {
    Link,
    useRouter
} from "@/navigation";

const { Text } = Typography;


export const AllRoles = () => {
    const t = useTranslations('permission_roles');
    const route = useRouter();
    const { data: session } = useSession();
    const { data: roles, isFetching } = useApi({
        route: { name: 'roles.all', query: { include: 'statistic' } },
        setting: {
            select: (resp) => resp.data,
        },
    });

    return (
        <>
            <Card
                title={t('title')}
                className={'roles'}
                extra={(
                    <Space>
                        {session?.user?.permissions?.includes('manage-roles') &&
                            <Link
                                href={'/roles/create'}
                            >
                                <AddButton>
                                    {t('add_role')}
                                </AddButton>
                            </Link>
                        }
                    </Space>
                )}
            >
                <Spin spinning={isFetching}>
                    <Row gutter={[16, 16]}>
                        {roles ? roles.map(item => (
                            <Col
                                key={item.id}
                                xs={24}
                                sm={12}
                                md={8}
                                lg={6}
                                xl={6}
                            >
                                <Card>
                                    <div className={style.card_head}>
                                        <div className={style.card_head_wrapper}>
                                            <div className={style.card_head_title}>
                                                {item.title ?? ''}
                                            </div>
                                            {session?.user?.permissions?.includes('manage-roles') &&
                                                <div className={style.card_head_extra}>
                                                    <OptionsButton
                                                        type={'dots'}
                                                        trigger={'hover'}
                                                        content={(
                                                            <Button
                                                                style={{
                                                                    width: '100%',
                                                                    display: 'flex',
                                                                    alignItems: 'center'
                                                                }}
                                                                type={'text'}
                                                                icon={<EditIcon />}
                                                                onClick={() => route.push(`/roles/${item.name}`)}
                                                            >
                                                                {t('edit')}
                                                            </Button>
                                                        )}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <Flex
                                        justify="space-between"
                                    >
                                        <Text>{t('users')}</Text>
                                        <Text>{item.statistic.user}</Text>
                                    </Flex>
                                    <Flex
                                        justify="space-between"
                                    >
                                        <Text>{t('permission')}</Text>
                                        <Text>{item.statistic.permission}</Text>
                                    </Flex>
                                    <Flex
                                        justify="space-between"
                                    >
                                        <Text>{t('level')}</Text>
                                        <RoleRate value={item.statistic.level} />
                                    </Flex>
                                    <Text
                                        style={{
                                            color: '#656565',
                                            marginTop: '8px',
                                            fontSize: '12px',
                                            lineHeight: '16px',
                                        }}>
                                        {item.description}
                                    </Text>
                                </Card>
                            </Col>
                        )) : null}
                    </Row>
                </Spin>
            </Card>
        </>
    );
}

const RoleRate = ({value}) =>{
    return (
        <>
            <Rate
                className={cn(style.rate_custom, {
                    [style.fill_green]: value >= 80 && value <= 100,
                    [style.fill_green_light]: value >= 60 && value <= 80,
                    [style.fill_yellow]: value >= 40 && value <= 60,
                    [style.fill_orange]: value >= 20 && value <= 40,
                    [style.fill_red]: value >=0 && value <= 20,
                })}
                disabled
                character={<CharacterIcon />}
                defaultValue={Math.round((5 * value) / 100)}
            />
        </>
    )
}